import axios from 'axios'
import * as HttpStatus from 'http-status-codes'
import { parseSafetyOverview, parseSafetyViolation, SafetyDashboard } from 'shared/models/safety'

// Apis
export function getSafetyDashboard(teamId: string): Promise<SafetyDashboard> {
  return axios
    .post(`/api/v1/console/teams/${teamId}/safety/dashboard/`)
    .then((response) => {
      return {
        violationsDetails: response.data.violations_details
          ? response.data.violations_details.map(parseSafetyViolation)
          : null,
        carrierOverview: response.data.carrier_overview
          ? parseSafetyOverview(response.data.carrier_overview)
          : null,
      }
    })
    .catch((err) => {
      if (err?.response?.status === HttpStatus.NOT_FOUND) {
        return {
          violationsDetails: null,
          carrierOverview: null,
        }
      }

      throw err
    })
}
